(() => {
    const isProductPage =
        document.body.classList.contains('template-product') ||
        location.pathname.startsWith('/products/');

    if (!isProductPage) return;

    const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();

    const parseJSON = (el) => {
        try { return JSON.parse(el.textContent || 'null'); } catch { return null; }
    };

    const getVariantsFromRoot = (root) => {
        const el = root.querySelector('script[type="application/json"]');
        const data = el ? parseJSON(el) : null;
        return Array.isArray(data) ? data : null;
    };

    const getHideMap = (root) => {
        const sectionId = root?.dataset.section;
        const sectionMap = sectionId
            ? document.getElementById(`variant-hide-map-${sectionId}`)
            : null;
        const el = sectionMap || document.querySelector('script[id^="variant-hide-map-"]');
        const data = el ? parseJSON(el) : null;
        return data && typeof data === 'object' ? data : null;
    };

    const getSelectedOptionsByName = (root) => {
        const map = {};
        root.querySelectorAll('fieldset.product-form__input').forEach((fs) => {
            const input = fs.querySelector('input[type="radio"]:checked');
            if (!input) return;

            // name del input suele ser "Color" o "Color-{{ section_id }}"
            const rawName = input.getAttribute('name') || '';
            const baseName = rawName.split('-')[0]; // "Color-xxx" => "Color"
            map[baseName] = norm(input.value);
        });
        return map;
    };

    const findVariantForColor = (variants, selectedMap, colorValue) => {
        const desiredColor = norm(colorValue);

        // Armamos el set deseado: todo lo seleccionado, pero con Color = desiredColor
        const desired = { ...selectedMap, Color: desiredColor, color: desiredColor };

        // El JSON de Shopify trae `options: ["ColorValue","OtherValue", ...]`
        // y también option1/option2/option3. Usamos options[] cuando existe, y fallback a option1/2.
        const matches = (v) => {
            if (Array.isArray(v.options) && v.options.length) {
                // Si el producto usa "Color" como option1 (muy común), esto basta:
                // Reglas:
                // - v.options[0] debe ser Color
                // - si existe un "Style" seleccionado, v.options debe contenerlo en alguna posición
                if (norm(v.options[0]) !== desiredColor) return false;

                // Si hay Style seleccionado, validarlo (si existe en map)
                const styleSel = selectedMap.Style || selectedMap.style;
                if (styleSel) {
                    // normalmente es options[1], pero lo verificamos por inclusión exacta
                    const ok = v.options.some((x) => norm(x) === norm(styleSel));
                    if (!ok) return false;
                }

                // Si hay Ring Type seleccionado, también (para Ring Set u otros)
                const ringSel = selectedMap['Ring Type'] || selectedMap['ring type'];
                if (ringSel) {
                    const ok = v.options.some((x) => norm(x) === norm(ringSel));
                    if (!ok) return false;
                }

                return true;
            }

            // Fallback si no existe options[]
            if (norm(v.option1) !== desiredColor) return false;

            const styleSel = selectedMap.Style || selectedMap.style;
            if (styleSel && v.option2 && norm(v.option2) !== norm(styleSel)) return false;

            return true;
        };

        return variants.find(matches) || variants.find((v) => norm(v.option1) === desiredColor) || null;
    };

    const applyToRoot = (root, variants, hideMap) => {
        const colorFieldset = root.querySelector('fieldset.product-form__input.Color');
        if (!colorFieldset) return;

        const colorSelectsStyle = root.dataset.colorSelectsStyle === 'true';
        const selectedMap = getSelectedOptionsByName(root);

        const colorInputs = [...colorFieldset.querySelectorAll('input.colors-js[type="radio"]')];

        const clickColorInput = (input) => {
            const wasSuppressed = root.suppressColorTierSwitch;
            if (colorSelectsStyle) root.suppressColorTierSwitch = true;
            try {
                input.click();
            } finally {
                if (colorSelectsStyle) {
                    if (wasSuppressed === undefined) delete root.suppressColorTierSwitch;
                    else root.suppressColorTierSwitch = wasSuppressed;
                }
            }
        };

        colorInputs.forEach((input) => {
            const label = colorFieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);

            const v = findVariantForColor(variants, selectedMap, input.value);
            const id = v?.id ? String(v.id) : null;

            const shouldHide = id ? hideMap[id] === true : false;

            // No uses display:none en el input; deshabilita para que el theme no lo seleccione
            input.disabled = shouldHide;

            if (label) {
                if (shouldHide) label.style.setProperty('display', 'none', 'important');
                else label.style.removeProperty('display');
            }

            // Si el que está checked se vuelve inválido, mueve a uno visible con click()
            if (shouldHide && input.checked) {
                const next = colorInputs.find((i) => {
                    const vv = findVariantForColor(variants, selectedMap, i.value);
                    const iid = vv?.id ? String(vv.id) : null;
                    return iid ? hideMap[iid] !== true : true;
                });
                if (next && next !== input) clickColorInput(next);
            }
        });
    };

    const init = () => {
        document.querySelectorAll('variant-radios').forEach((root) => {
            if (root.dataset.hideSwatchesInit === '1') return;

            const hideMap = getHideMap(root);
            if (!hideMap) return;

            const variants = getVariantsFromRoot(root);
            if (!variants) return;

            root.dataset.hideSwatchesInit = '1';

            const run = () => applyToRoot(root, variants, hideMap);

            // Inicial
            run();

            // Cambios de cualquier radio (Color, Style, Ring Type, etc.)
            root.addEventListener('change', (e) => {
                const t = e.target;
                if (t && t.matches && t.matches('fieldset.product-form__input input[type="radio"]')) run();
            });

            // Si el theme re-renderiza el bloque, re-aplica
            const mo = new MutationObserver(() => run());
            mo.observe(root, { childList: true, subtree: true });
        });
    };

    // Espera a que el DOM esté listo y el theme haya montado variant-radios
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
